import * as React from 'react';
// import {useNavigate} from 'react-router-dom';
import { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import CssBaseline from '@mui/material/CssBaseline';
import { Stack } from '@mui/material';
import MainTitle from './MainTitle';

export default (props) => {

   // const navigate = useNavigate();

    const [color,setColor] = useState('#222222');
    useEffect(()=>{console.log('18 ****** ',props.color);
        if( props.color != undefined ){ setColor(props.color); } 
    },[]);


    return (
        <>
            <Stack direction="row" sx={{ height: '60px', alignItems: 'center', justifyContent: 'space-between', paddingLeft: '18px', paddingRight: '18px' }}>


                <MainTitle color={color} />
                
                <Box sx={{ fontSize: '13px', display: 'flex', fontFamily: 'Roboto,San-Serif', fontSize: '13px' }}>
                    <div style={{ cursor: 'pointer', height: '60px', lineHeight: '60px', minWidth: '11px', paddingLeft: '0px', paddingRight: '10px', marginRight: '4px', textAlign: 'center', color: `${props.lang == 'en'? '#222222':'#aaaaaa'}` }} onClick={() => { /*navigate('/'+props.lang+'/signup')*/ }}>
                        ENGLISH
                    </div>
                    {/*<div style={{cursor:'pointer',height:'60px',lineHeight:'60px',minWidth:'11px',paddingLeft:'0px',paddingRight:'8px',color:'#666666',textAlign:'center'}} onClick={()=>{navigate('/kr/corp/signup')}}>
                SPANISH
            </div>*/}
                    <div style={{ cursor: 'pointer', height: '60px', lineHeight: '60px', minWidth: '11px', paddingLeft: '0px', paddingRight: '8px', color: '#aaaaaa', textAlign: 'center', color: `${props.lang == 'ko'? '#222222':'#aaaaaa'}` }} onClick={() => { /*navigate('/'+props.lang+'/login')*/ }}>
                        한국어
                    </div>
                    <div style={{ cursor: 'pointer', height: '60px', lineHeight: '60px', minWidth: '11px', paddingLeft: '0px', paddingRight: '8px', color: '#aaaaaa', marginRight: '30px', textAlign: 'center', color: `${props.lang == 'ja'? '#222222':'#aaaaaa'}` }} onClick={() => { /*navigate('/'+props.lang+'/corp/signup')*/ }}>
                        日本語
                    </div>
                    <div style={{ cursor: 'pointer', height: '60px', lineHeight: '60px', minWidth: '11px', paddingLeft: '0px', paddingRight: '8px', textAlign: 'center', color: `${props.page == 'signup'? '#222222':'#aaaaaa'}` }} onClick={() => { /*navigate('/'+props.lang+'/signup')*/ }}>
                        Signup
                    </div>
                    <div style={{ cursor: 'pointer', height: '60px', lineHeight: '60px', minWidth: '11px', paddingLeft: '0px', paddingRight: '8px', textAlign: 'center', color: `${props.page == 'login'? '#222222':'#aaaaaa'}` }} onClick={() => { /*n avigate('/'+props.lang+'/login')*/ }}>
                        Login
                    </div>
                </Box>
            </Stack>

        </>
    );
}